import React, { useState, useEffect, lazy, Suspense, useMemo } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { userCustomerList, userMasterActiveList } from "api";
import { useDispatch, useSelector } from "react-redux";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./PricingChart.css";
import { priceChartType } from "../../redux/type";
import {
  priceChartAction,
  suggectionDataAction,
} from "../../redux/actions/priceChart.action";
import { lotCodeListAction } from "../../redux/actions/lotCode.action";

import {
  cscListAction,
  cscListSelelctAction,
} from "../../redux/actions/auth.action";
import {
  rmNames,
  CommodityGroup,
  mapping,
  rmId,
} from "content/priceChart.static";
import Loading from "components/Event/Loading";
import LoadingModel from "components/Event/LoadingModel";

const TableContent = lazy(() =>
  import("section/PricingChartSection/TableContent")
);

const TabsTable = () => {
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [currency, setCurrency] = useState("INR");
  const [customerOptions, setCustomerOptions] = useState([]);
  const { user, cscList } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [updatedSubAreaId, setupdatedSubAreaId] = useState("");
  const [key, setKey] = useState("Diamond");
  const [errorMessage, setErrorMessage] = useState();
  const [showError, setShowError] = useState(false);
  const {
    lotCodeDiamond,
    lotCodePrecious,
    lotCodeSemiPrecious,
    lotCodeChain,
    lotCodeFinding,
  } = useSelector((state) => state.lotCode);

  const {
    pricingChartDetails,
    message,
    customerCode,
    tempPricingChartRow,
    internal,
    Commodity,
    shape,
    color,
    error,
    SieveSize,
    MMSize,
    isLoading: isLoad,
  } = useSelector((state) => state.priceChart);
  
  const eisId = user.eisId;

  let storedCscId = localStorage.getItem("loggedCscId");
  let storedSubareaId = localStorage.getItem("loggedSubareaId");
  let storedCscName = localStorage.getItem("loggedCscName");

  localStorage.setItem("loggedCscId", storedCscId);
  localStorage.setItem("loggedSubareaId", storedSubareaId);
  localStorage.setItem("loggedCscName", storedCscName);

  const componentDetails = pricingChartDetails?.ComponentDetails;

  //=======================================================================

  const dispatch = useDispatch();

  useEffect(() => {
    if (!cscList) {
      dispatch(cscListAction(eisId));
    }
  }, [key]);

  useEffect(() => {
    if (storedSubareaId === "9") {
      setCurrency("INR");
    } else {
      setCurrency("USD");
    }
  }, [storedSubareaId]);

  useEffect(() => {
    if (selectedCustomer.length === 0) {
      setSelectedCustomer(customerCode);
    }
  }, [customerCode]);

  const submitHandler = (e) => {
    if (
      !selectedCustomer ||
      selectedCustomer === "" ||
      selectedCustomer === undefined
    ) {
      setErrorMessage("Please Select Customer Code");
      setShowError(true);
    }

    if (selectedCustomer && selectedCustomer.value !== undefined) {
      setErrorMessage("");
      setShowError(false);

      // Hide modal regardless of error state
      //setShowModal(false);

      dispatch(priceChartAction(selectedCustomer, currency));
    }
  };

  //=========================================================================================================//

  const setErrorHandle = (value) => {
    setErrorMessage(value);
  };

  const handleCustomerSelect = (selectedOption, { action }) => {
    if (action === "input-change" && selectedOption.length >= 4) {
      if (user.role === "user") {
        fetchCustomerUserList(selectedOption);
      } else {
        fetchCustomerAdminList(selectedOption);
      }
    }
  };

  const fetchCustomerUserList = async (selectedOption) => {
    try {
      setIsLoading(true);
      const requestBody = {
        EmployeeId: eisId,
        CSCId: storedCscId,
        updatedSubAreaId: storedSubareaId,
      };

      const response = await userCustomerList(requestBody);

      const options = response.data.data.map((item) => ({
        value: item.MappedCustomerCode,
        label: `${item.MappedCustomerCode} - [${item.CustomerAliasName}]`,
      }));
      setCustomerOptions(options);
      setErrorHandle("customerCode", undefined);
      setIsLoading(false);
      setupdatedSubAreaId(options.value);
    } catch (error) {
      //setError(error);
    }
  };

  const fetchCustomerAdminList = async (selectedOption) => {
    try {
      setIsLoading(true);
      const requestBody = {
        SubareaId: storedSubareaId,
      };
      const res = await userMasterActiveList(requestBody);

      const options = res.data.data.map((item) => ({
        value: item.CustomerCode,
        label: `${item.CustomerCode}`, 
        // - [${item.LastName}]`,
        // lastName: item.LastName,
      }));
      setCustomerOptions(options);
      setIsLoading(false);
    } catch (error) {
      // setError(error);
    }
  };

  const handleTabChange = (selectedTab, RM, selectedCustomer, rmId) => {
    switch (selectedTab) {
      case "ERM1":
      case "ERM2":
      case "ERM3":
      case "ERM7":
      case "ERM8":
        dispatch(lotCodeListAction(storedSubareaId, selectedTab, rmId));
        dispatch(
          suggectionDataAction(
            RM,
            selectedCustomer,
            storedSubareaId,
            selectedTab,
            rmId
          )
        );
        break;
      default:
        dispatch(lotCodeListAction(storedSubareaId, selectedTab, rmId));
        dispatch(
          suggectionDataAction(
            RM,
            selectedCustomer,
            storedSubareaId,
            selectedTab,
            rmId
          )
        );
    }
  };

  const getLotCodeAction = (rm, eventKey) => {
    switch (rm) {
      case "Diamonds":
        return eventKey === "ERM1"
          ? {
              lotCode: lotCodeDiamond,
              eventKey,
              internal,
              Commodity,
              shape,
              color,
              MMSize,
              SieveSize,
            }
          : undefined;
      case "Precious Color Stones":
        return eventKey === "ERM2"
          ? {
              lotCode: lotCodePrecious,
              eventKey,
              internal,
              Commodity,
              shape,
              color,
              MMSize,
              SieveSize,
            }
          : undefined;
      case "Semi Precious Stones":
        return eventKey === "ERM3"
          ? {
              lotCode: lotCodeSemiPrecious,
              eventKey,
              internal,
              Commodity,
              shape,
              color,
              MMSize,
              SieveSize,
            }
          : undefined;
      case "Chain":
        return eventKey === "ERM8"
          ? {
              lotCode: lotCodeChain,
              eventKey,
              internal,
              Commodity,
              shape,
              color,
              MMSize,
              SieveSize,
            }
          : undefined;
      case "Finding":
        return eventKey === "ERM7"
          ? {
              lotCode: lotCodeFinding,
              eventKey,
              internal,
              Commodity,
              shape,
              color,
              MMSize,
              SieveSize,
            }
          : undefined;
      default:
        return undefined;
    }
  };

  const getComponentDetailsData = (rm) => {
    if (
      tempPricingChartRow &&
      tempPricingChartRow.rmNames === rm &&
      componentDetails[rm]?.data
    ) {
      return [tempPricingChartRow, ...componentDetails[rm]?.data];
    } else {
      return componentDetails[rm]?.data;
    }
  };

  const handleCscOpration = (e) => {
    dispatch(cscListSelelctAction(e));
    setSelectedCustomer("");
    if (selectedCustomer) {
      dispatch(priceChartAction("", currency));
    }
  };

  // const handleChageSubArea = () => {
  //   if (storedSubareaId === "9") {
  //     setCurrency("INR");
  //   } else {
  //     setCurrency("USD");
  //   }
  // };

  const handleCustomerCode = (e) => {
    setSelectedCustomer(e);
    //   dispatch({type:priceChartType.SAVE_CUSTOMER_CODE,
    //     payload:{customerCode:e}
    // })
    if (e) {
      setErrorHandle(undefined);
    } else {
      dispatch(priceChartAction("", currency));
      setErrorHandle("Please Select customerCode");
    }
  };

  const renderTab = useMemo(() => {
    return (rm, key, eventKey, title, count, index) => (
      <Tab
        key={index}
        eventKey={eventKey}
        title={
          <div className="d-flex align-items-center justify-content-center position-relative">
            {title}
            {activeTab === rm && count > 0 && (
              <span className="totalCount-badge position-absolute top-0 start-100 translate-middle badge text-white bg-info">
                {count} count
              </span>
            )}
          </div>
        }
      >
        <Suspense
          fallback={
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100vh" }}
            >
              <Loading />
            </div>
          }
        >
          <TableContent
            storedSubareaId={storedSubareaId}
            lotCodeAction={getLotCodeAction(rm, eventKey)}
            selectedCustomer={selectedCustomer}
            ComponentDetailsName={rm}
            pricingChartDetails={pricingChartDetails}
            componentDetails={componentDetails?.[rm]}
            componentDetailsData={getComponentDetailsData(
              rm === undefined ? "" : rm
            )}
          />
        </Suspense>
      </Tab>
    );
  }, [
    activeTab,
    componentDetails,
    getComponentDetailsData,
    getLotCodeAction,
    pricingChartDetails,
    selectedCustomer,
    storedSubareaId,
  ]);

  return (
    <>
      <div className="container-fluid pt-1">
        {/* <div className="row pt-1 pb-1">
          <div className="col-md-2 p-0">
            <div className="form-group mx-5 mb-md-0">
              <h3>CustomerChart</h3>
            </div>
          </div>
        </div> */}
        <LoadingModel show={isLoad} />
        <div className="row d-flex justify-content-around mb-4 px-2">
          {/* <div className="col-md-1 pr-1">
            <div className="form-group mr-2">
              <h3>CustomerChart</h3>
            </div>
          </div> */}

          <div className="col-md-4 mb-md-0 pr-md-0">
            <label htmlFor="selectCsc" className="form-label">
              Switch CSC
            </label>
            <select
              className="form-control w-100"
              required
              id="selectCsc"
              onChange={(e) => {
                if (e) {
                  handleCscOpration(e);
                }
              }}
              // onBlur={() => {
              //   handleChageSubArea();
              // }}
              value={`${storedCscId}~${storedSubareaId}~${storedCscName}`}
            >
              {cscList?.map((list) => (
                <option
                  key={list.cscId}
                  value={`${list.cscId}~${list.subareaId}~${list.cscName}`}
                >
                  {list.cscName} - {list.cscId} - {list.cscCode}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-4 mb-2 mb-md-0 pr-md-0 ">
            <label className="form-label">Customer Code</label>
            <Select
              value={selectedCustomer}
              onChange={(e) => {
                handleCustomerCode(e);
              }}
              onInputChange={handleCustomerSelect}
              options={customerOptions}
              required
              className={`style-select multiple-select ${
                errorMessage ? "select-invalid" : ""
              } ${selectedCustomer ? "" : ""}`}
              isSearchable={true}
              placeholder="Enter Customer Code & Select"
              isClearable={true}
              isLoading={isLoading}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  backgroundColor: errorMessage ? "#F8D7DA" : "white",
                }),
              }}
            />
            {errorMessage && (
              <span className="validation_error">{errorMessage}</span>
            )}
          </div>

          <div className="col-md-3 mb-2 mb-md-0 pr-md-0">
            <label className="form-label">Currency</label>
            <select
              className="form-control w-100"
              onChange={(e) => {
                setCurrency(e.target.value);
              }}
              value={currency}
            >
              {["INR", "USD"].map((currency, index) => (
                <option value={currency} key={index}>
                  {currency}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-1  align-items-center  justify-content-end">
            <button
              onClick={submitHandler}
              className="btn btn-primary w-100 "
              style={{ marginTop: "42px" }}
            >
              Submit
            </button>
          </div>
        </div>

        <div className="px-2  position-relative">
          <Suspense
            fallback={
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100vh" }}
              >
                <Loading />
              </div>
            }
          >
            {componentDetails ? (
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => {
                  setKey(k);
                  const result = mapping[k] || "";
                  setActiveTab(result);
                  dispatch({
                    type: priceChartType.PRIICNG_CHART_RM_SET,
                    payload: result,
                  });
                  let tabRmId = rmId[result];

                  handleTabChange(k, result, selectedCustomer, tabRmId);
                }}
                className="mb-2 fluid-container position-relative"
              >
                {rmNames.map((rm, index) => {
                  const commodityGroupMap = {
                    Diamonds: CommodityGroup.Diamonds,
                    "Precious Color Stones": CommodityGroup.PreciousColorStones,
                    "Semi Precious Stones": CommodityGroup.SemiPreciousStones,
                    Chain: CommodityGroup.Chain,
                    Finding: CommodityGroup.Finding,
                  };

                  const commodityGroup = commodityGroupMap[rm];
                  const count =
                    componentDetails[rm]?.pagination.totalcount || 0;
                  const tabElement = renderTab(
                    rm,
                    componentDetails[rm]?.data[0]?.RM,
                    commodityGroup,
                    rm,
                    count,
                    index
                  );
                  return tabElement || null;
                })}
              </Tabs>
            ) : componentDetails === undefined && message ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "70vh", color: "red" }}
              >
                <h4>{error}</h4>
              </div>
            ) : (
              <></>
            )}
          </Suspense>
        </div>
      </div>
    </>
  );
};

TabsTable.propTypes = {
  rm: PropTypes.string,
  key: PropTypes.any,
  eventKey: PropTypes.any,
  title: PropTypes.any,
  componentDetails: PropTypes.object,
  selectedCustomer: PropTypes.any,
};

export default TabsTable;
